{
  "title.notification": "Claude Code — Attention required",
  "title.stop": "Claude Code — Task complete",
  "title.stopFailure": "Claude Code — API error",
  "title.subagentStop": "Claude Code — Subagent finished",
  "title.subagentStart": "Claude Code — Subagent started",
  "title.taskCreated": "Claude Code — Task created",
  "title.taskCompleted": "Claude Code — Task completed",
  "title.preCompact": "Claude Code — Compacting context",
  "title.postCompact": "Claude Code — Context compacted",
  "body.stop": "Waiting for your next input",
  "body.notification.fallback": "Claude Code needs your attention",
  "body.stopFailure.fallback": "The session ended with an error (rate limit, billing, auth, etc.)",
  "body.subagentStop.fallback": "A subagent finished",
  "body.subagentStop.named": "Subagent '{agent}' finished",
  "body.subagentStart.fallback": "A subagent started working",
  "body.subagentStart.named": "Subagent '{agent}' started working",
  "body.taskCreated.fallback": "A new task was created",
  "body.taskCreated.named": "✓ New task: {task}",
  "body.taskCompleted.fallback": "A task was completed",
  "body.taskCompleted.named": "✓ {task}",
  "body.taskCompleted.named_counted": "✓ {task} ({completed}/{total})",
  "body.preCompact.fallback": "The conversation history is being compacted",
  "body.preCompact.manual": "Compacting history (you requested it)",
  "body.preCompact.auto": "Compacting history automatically",
  "body.postCompact.fallback": "The conversation history was compacted",
  "body.postCompact.manual": "History compacted (you requested it)",
  "body.postCompact.auto": "History compacted automatically",
  "notification.type.permission_prompt": "Permission required to run a tool",
  "notification.type.idle_prompt": "Waiting for your response",
  "notification.type.auth_success": "Authentication succeeded",
  "notification.type.elicitation_dialog": "MCP server is requesting information",
  "notification.type.elicitation_complete": "MCP server request completed",
  "notification.type.elicitation_response": "Response sent to MCP server",
  "notification.tool_permission": "Permission required to use {tool}",
  "notification.waiting_input": "Waiting for your response",
  "notification.attention": "Claude Code needs your attention",
  "notification.attention_generic": "Attention required",
  "stopFailure.type.rate_limit": "Usage limit reached — wait for your quota to reset",
  "stopFailure.type.authentication_failed": "Authentication failed — your session expired or the token is invalid",
  "stopFailure.type.oauth_org_not_allowed": "Organization not allowed to use this account",
  "stopFailure.type.billing_error": "Billing error — check your plan and payment method",
  "stopFailure.type.invalid_request": "Invalid request sent to the API",
  "stopFailure.type.model_not_found": "Selected model not found or unavailable",
  "stopFailure.type.server_error": "Anthropic server error — try again in a moment",
  "stopFailure.type.max_output_tokens": "Output token limit reached for this response",
  "stopFailure.type.unknown": "Unknown error ended the session",
  "stopFailure.fallback.rate_limit": "Usage limit reached",
  "stopFailure.fallback.authentication": "Authentication failed",
  "stopFailure.fallback.billing": "Billing error",
  "stopFailure.fallback.invalid_request": "Invalid request",
  "stopFailure.fallback.model": "Model unavailable",
  "stopFailure.fallback.server": "Anthropic server error",
  "stopFailure.fallback.max_tokens": "Output token limit reached",
  "tui.welcome.title": "Welcome to Ringly",
  "tui.welcome.tagline": "Native cross-platform notifications for {target}.",
  "tui.welcome.steps_intro": "We'll guide you through {count} quick steps:",
  "tui.welcome.step1": "1 · Choose your notification language",
  "tui.welcome.step2": "2 · Pick which events should notify you",
  "tui.welcome.step3": "3 · Sound & debug preferences",
  "tui.welcome.step4": "4 · Set up the status line",
  "tui.welcome.step5": "5 · Register the Windows integration",
  "tui.language.title": "Notification language",
  "tui.language.subtitle": "Pick the language used in toast titles and bodies.",
  "tui.language.option.auto": "Auto  —  follow system locale",
  "tui.language.option.ptbr": "Português  (pt-BR)",
  "tui.language.option.enus": "English  (en-US)",
  "tui.events.title": "Choose which events should notify you",
  "tui.events.subtitle": "{enabled} of {total} enabled",
  "tui.events.notification.label": "Permission / input requests",
  "tui.events.notification.desc": "Notify when Claude needs your attention",
  "tui.events.stop.label": "Task complete",
  "tui.events.stop.desc": "Notify when Claude finishes a response",
  "tui.events.stopFailure.label": "API errors",
  "tui.events.stopFailure.desc": "Notify when an API error ends the session",
  "tui.events.subagentStop.label": "Subagent finished",
  "tui.events.subagentStop.desc": "Notify when a subagent completes (off by default)",
  "tui.events.subagentStart.label": "Subagent started",
  "tui.events.subagentStart.desc": "Notify when a subagent starts (verbose, off by default)",
  "tui.events.taskCreated.label": "Task created",
  "tui.events.taskCreated.desc": "Notify when a task is created (verbose, off by default)",
  "tui.events.taskCompleted.label": "Task completed",
  "tui.events.taskCompleted.desc": "Notify when a task is completed (verbose, off by default)",
  "tui.events.preCompact.label": "Compacting context",
  "tui.events.preCompact.desc": "Notify before history is compacted (verbose, off by default)",
  "tui.events.postCompact.label": "Context compacted",
  "tui.events.postCompact.desc": "Notify after history is compacted (verbose, off by default)",
  "tui.sound.title": "Sound and logging",
  "tui.sound.subtitle": "Toggle sound and verbose logging.",
  "tui.sound.sound.label": "Play notification sounds",
  "tui.sound.sound.desc": "Plays the OS toast sound on every event",
  "tui.sound.debug.label": "Write debug logs",
  "tui.sound.debug.desc": "Verbose log file (rotated by size)",
  "tui.statusline.title": "Status line (terminal bottom bar)",
  "tui.statusline.subtitle": "{enabled} of {total} segments shown",
  "tui.statusline.explain": "A bar at the bottom of Claude Code showing model, current task, context usage, git and rate limits. Only one status line can be active — enabling this replaces your current one (Ringly backs it up and restores it if you turn this off).",
  "tui.statusline.enabled.label": "Enable the Ringly status line",
  "tui.statusline.enabled.desc": "Master switch — installs/removes the bar",
  "tui.statusline.off_hint": "The status line is off — turn it on above to use these segments.",
  "tui.statusline.position.label": "Context meter position",
  "tui.statusline.position.desc": "Where the context bar sits (←/→ to switch)",
  "tui.statusline.position.end": "end",
  "tui.statusline.position.front": "front",
  "tui.statusline.footer.position": "position",
  "tui.statusline.segment.model.label": "Model",
  "tui.statusline.segment.model.desc": "The current model name",
  "tui.statusline.segment.task.label": "Current task",
  "tui.statusline.segment.task.desc": "The in-progress task, in bold",
  "tui.statusline.segment.dirname.label": "Directory",
  "tui.statusline.segment.dirname.desc": "The working directory name",
  "tui.statusline.segment.context.label": "Context meter",
  "tui.statusline.segment.context.desc": "Context-window usage bar (colored)",
  "tui.statusline.segment.lastCommand.label": "Last command",
  "tui.statusline.segment.lastCommand.desc": "The last slash command you ran (off by default)",
  "tui.statusline.segment.git.label": "Git status",
  "tui.statusline.segment.git.desc": "Branch + ahead/behind/dirty counts",
  "tui.statusline.segment.lines.label": "Lines changed",
  "tui.statusline.segment.lines.desc": "Lines added/removed this session",
  "tui.statusline.segment.rateLimits.label": "Rate limits",
  "tui.statusline.segment.rateLimits.desc": "5-hour / 7-day usage (Pro/Max only)",
  "tui.aumid.title": "Register Windows integration",
  "tui.aumid.subtitle": "Creating Start Menu shortcut and AUMID for Windows toasts.",
  "tui.aumid.running": "Setting up Windows integration…",
  "tui.aumid.success": "Windows integration ready",
  "tui.aumid.already": "(already registered, no changes needed)",
  "tui.aumid.notif_setting": "Notification setting:",
  "tui.aumid.error": "Registration failed",
  "tui.aumid.error_unknown": "unknown error",
  "tui.aumid.retry_hint": "Try {command} after fixing the issue.",
  "tui.done.ready": "Ringly is ready",
  "tui.done.final_step": "Final step:",
  "tui.done.final_step_body": "register the plugin inside Claude Code.",
  "tui.done.useful_commands": "Useful commands:",
  "tui.done.cmd_doctor": "verify the setup",
  "tui.done.cmd_config": "change settings",
  "tui.done.cmd_test": "fire a sample notification",
  "tui.config.saved": "Configuration saved",
  "tui.config.written_to": "Written to",
  "tui.config.backup_created": "A timestamped backup of the previous file was created next to it.",
  "tui.config.reload_required": "Reload required",
  "tui.config.reload_body": "Run {command} inside Claude Code so the new",
  "tui.config.reload_body2": "settings take effect immediately.",
  "tui.config.cli_only_title": "CLI-only configuration",
  "tui.config.cli_only_body": "Ringly does not use the Claude Code {plugin} screen. To change these settings later, run {command} again or edit ~/.claude/settings.json directly.",
  "tui.footer.continue": "continue",
  "tui.footer.cancel": "cancel",
  "tui.footer.move": "move",
  "tui.footer.select": "select",
  "tui.footer.toggle": "toggle",
  "tui.footer.confirm": "confirm",
  "tui.header.step": "Step {step}/{total}",
  "cli.doctor.header": "Ringly diagnostics",
  "cli.doctor.summary": "Summary:",
  "cli.doctor.passed": "{count} passed",
  "cli.doctor.warning": "{count} warning",
  "cli.doctor.warnings": "{count} warnings",
  "cli.doctor.failed": "{count} failed",
  "cli.doctor.log_file": "Log file:",
  "cli.doctor.check.node": "Node.js version",
  "cli.doctor.check.platform": "Operating system",
  "cli.doctor.check.platform.scaffolded": "{platform} support is scaffolded but not implemented yet",
  "cli.doctor.check.platform.star_hint": "Star the GitHub repo to be notified when macOS / Linux land.",
  "cli.doctor.check.platform.unsupported_hint": "Ringly currently supports Windows only.",
  "cli.doctor.check.platform.future_hint": "Native toast on this platform will arrive in a future release.",
  "cli.doctor.check.node.hint": "Node 20 or newer is required. Upgrade from nodejs.org or via nvm/volta.",
  "cli.doctor.check.powershell": "PowerShell",
  "cli.doctor.check.powershell.unreachable": "PowerShell not reachable",
  "cli.doctor.check.powershell.hint": "Make sure powershell.exe is on the PATH.",
  "cli.doctor.check.claude": "Claude Code executable",
  "cli.doctor.check.claude.notfound": "not found",
  "cli.doctor.check.claude.hint": "The AUMID will use a fallback target. Run {command} after installing Claude Code.",
  "cli.doctor.check.aumid": "Windows AUMID",
  "cli.doctor.check.aumid.notreg": "not registered",
  "cli.doctor.check.aumid.notreg_hint": "Run {command} to register the Start Menu shortcut and AUMID.",
  "cli.doctor.check.aumid.mismatch_hint": "AUMID exists but does not match the expected value. Run {command}.",
  "cli.doctor.check.aumid.missing": "missing property",
  "cli.doctor.check.aumid.repair_hint": "Run {command} to repair the AUMID.",
  "cli.doctor.check.plugin": "Ringly settings in ~/.claude/settings.json",
  "cli.doctor.check.plugin.notfound": "{file} not found",
  "cli.doctor.check.plugin.notfound_hint": "Run {command} to configure via the TUI (Ringly does not use Claude Code's plugin manager screen).",
  "cli.doctor.check.plugin.nooptions": "no Ringly options set (using built-in defaults)",
  "cli.doctor.check.plugin.nooptions_hint": "Run {command} to open Ringly's TUI configurator.",
  "cli.doctor.check.plugin.ok": "{count} option(s) set · language: {language}",
  "cli.doctor.check.statusline": "Status line",
  "cli.doctor.check.statusline.script_missing": "renderer script not found",
  "cli.doctor.check.statusline.script_missing_hint": "The bundled renderer is missing. Reinstall Ringly, then run {command}.",
  "cli.doctor.check.statusline.not_wired": "enabled, but settings.statusLine doesn't point at Ringly",
  "cli.doctor.check.statusline.not_wired_hint": "Run {command} and toggle the status line off and on to re-install it.",
  "cli.doctor.check.statusline.hooks_disabled": "disableAllHooks is on — the status line won't run",
  "cli.doctor.check.statusline.hooks_disabled_hint": "Set disableAllHooks to false in ~/.claude/settings.json.",
  "cli.test.intro": "Sending a test notification",
  "cli.test.title_label": "Title:",
  "cli.test.body_label": "Body:",
  "cli.test.done": "Done. Check your notification center if nothing appeared.",
  "cli.test.log_label": "Log:",
  "cli.test.header": "Ringly test",
  "cli.uninstall.header": "Ringly uninstall",
  "cli.uninstall.shortcut_removed": "Removed Start Menu shortcut",
  "cli.uninstall.shortcut_failed": "Failed to remove shortcut: {message}",
  "cli.uninstall.shortcut_absent": "Shortcut not present (skipping)",
  "cli.uninstall.config_removed": "Removed Ringly settings from ~/.claude/settings.json",
  "cli.uninstall.config_absent": "No Ringly settings present in ~/.claude/settings.json (skipping)",
  "cli.uninstall.config_failed": "Failed to remove config: {message}",
  "cli.uninstall.statusline_restored": "Restored your previous status line",
  "cli.uninstall.statusline_absent": "No Ringly status line to restore (skipping)",
  "cli.statusline.install_failed": "Couldn't install the status line (renderer not found). Try reinstalling Ringly.",
  "cli.uninstall.next_steps": "Next steps",
  "cli.uninstall.remove_plugin": "Remove the plugin from Claude Code:",
  "cli.uninstall.remove_npm": "Remove the npm CLI:",
  "cli.init.header_noninteractive": "Ringly init  ·  non-interactive",
  "cli.init.default_saved": "Default config saved",
  "cli.init.aumid_registered": "AUMID registered",
  "cli.init.aumid_skipped": "AUMID skipped: {reason}",
  "cli.init.next_steps_in_claude": "Next steps inside Claude Code",
  "cli.config.requires_tty": "`config` requires an interactive terminal. Pass settings via env vars or edit",
  "cli.config.requires_tty2": "the ~/.claude/settings.json file directly.",
  "cli.config.save_failed": "Failed to save settings: {message}",
  "cli.update.header": "Ringly update",
  "cli.update.current_version": "Installed version",
  "cli.update.latest_version": "Latest on npm",
  "cli.update.already_latest": "You're already on the latest version — {version}.",
  "cli.update.available": "New version available: {latest} (you're on {current}).",
  "cli.update.check_failed": "Couldn't reach the npm registry (offline or registry unavailable).",
  "cli.update.confirm_prompt": "Update to {latest}? [s/N]",
  "cli.update.confirm_prompt_en": "Update to {latest}? [y/N]",
  "cli.update.aborted": "Update aborted.",
  "cli.update.installing": "Installing ringly@{version}…",
  "cli.update.install_succeeded": "Update complete. Run /reload-plugins inside Claude Code, or close and reopen the session.",
  "cli.update.install_failed": "Failed to run `npm install -g ringly@latest`. Check permissions and try manually.",
  "cli.update.install_failed_windows_locked": "Update failed — Claude Code probably has files locked. Close Claude Code and run manually: npm install -g ringly@latest",
  "cli.update.run_manually": "Equivalent command: {command}",
  "cli.update.toast_body": "Version {latest} is available (you're on {current}). Run /ringly-update inside Claude Code.",
  "cli.update.notes_heading": "What's new in version {version}",
  "cli.update.notes_group.added": "What's new",
  "cli.update.notes_group.changed": "Changes",
  "cli.update.notes_group.fixed": "Fixes",
  "cli.update.notes_group.breaking": "⚠ Breaking changes",
  "cli.update.notes_group.removed": "Removed",
  "cli.update.notes_group.other": "More details",
  "cli.help.header": "Ringly commands",
  "cli.help.intro": "Overview of the commands available in the CLI.",
  "cli.help.warning_external_terminal": "⚠ Run these commands in your terminal (PowerShell, Bash, etc.), not inside Claude Code's chat.",
  "cli.help.usage_label": "Usage:",
  "cli.help.usage_value": "ringly <command> [options]",
  "cli.help.commands_label": "Commands:",
  "cli.help.options_label": "Global options:",
  "cli.help.option.help": "Show this help",
  "cli.help.option.version": "Show the installed version",
  "cli.help.footer": "For details on a specific command: `ringly <command> --help`",
  "cli.help.command.test": "Send a sample notification to verify the setup",
  "cli.help.command.init": "Interactive installer (register AUMID, pick options, link the plugin)",
  "cli.help.command.config": "Open the interactive configuration UI",
  "cli.help.command.doctor": "Run a diagnostic of the current environment",
  "cli.help.command.update": "Check npm for a newer Ringly release and optionally install it",
  "cli.help.command.uninstall": "Remove the AUMID shortcut and local configuration",
  "cli.help.command.help": "Show this list of commands"
}
